import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import {
  IconButton,
  IconButtonProps,
  Typography,
  useTheme,
} from "@mui/material";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { Box } from "@mui/system";

interface ITablePaginationProps {
  count: number;
  onPageChange: (e: any, page: number) => void;
  page: number;
  rowsPerPage: number;
  nextIconButtonProps?: Partial<IconButtonProps>;
  extraFetchFactor?: number;
}

export const TablePaginationActions: React.FC<ITablePaginationProps> = (
  props
) => {
  const theme = useTheme();
  const {
    page,
    onPageChange,
    nextIconButtonProps = { disabled: false },
  } = props;

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onPageChange(event, page + 1);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2, display: "flex", alignItems: "center" }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        sx={{
          borderRadius: "4px",
          px: 0.8,
          py: 0.4,
          color: page === 0 ? "action.disabled" : "#6c85b1",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight sx={{ fontSize: 18, mr: 0.5 }} />
        ) : (
          <KeyboardArrowLeft sx={{ fontSize: 18, mr: 0.5 }} />
        )}
        <Typography variant="body2" sx={{ color: "inherit", fontWeight: 400 }}>
          Back
        </Typography>
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={nextIconButtonProps.disabled}
        aria-label="next page"
        sx={{
          borderRadius: "4px",
          px: 0.8,
          py: 0.4,
          ml: 1,
          color: nextIconButtonProps.disabled ? "action.disabled" : "#6c85b1",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        <Typography variant="body2" sx={{ color: "inherit", fontWeight: 400, mr: 0.5 }}>
          Next
        </Typography>
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft sx={{ fontSize: 18 }} />
        ) : (
          <KeyboardArrowRight sx={{ fontSize: 18 }} />
        )}
      </IconButton>
    </Box>
  );
};
